module.exports = __webpack_public_path__ + "ce1b0a15db42f822f6e0c3a489259285.MP3";